/**
 * Qustodio Core public scripts.
 *
 * Import here the JS modules you want to include in the main JS file of the
 * plugin (assets/dist/js/public.min.js).
 */

import visitorAttribution from './api/visitorAttribution';

document.addEventListener('DOMContentLoaded', () => {
  visitorAttribution.init();
});
